import { ButtonHeading, CommonDateRange, CustomPagination, CustomToolTip } from 'components';
import BootstrapTable from 'components/BootstrapTable';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import { getPaymentTransactionListApi } from '_services/accountingServices/accountingServices';
import StorageService from 'utils/StorageServices';
import { FaRegTrashCan } from 'react-icons/fa6';

const PaymentTransaction = () => {
    const [activeTab, setActiveTab] = useState(1);
    const [paymentTransactionList, setPaymentTransactionList] = useState([]);
    const [totalItems, setTotalItem] = useState(0);
    const [offset, setOffset] = useState(1);
    const itemsPerPage = 10;
    const navigate = useNavigate();

    const columns = [
        { header: "# Number", accessor: "number" },
        { header: "Voucher Date", accessor: "voucher_date" },
        { header: "Firm name", accessor: "firm_name" },
        { header: "Vendor", accessor: "vendor" },
        { header: "Total Amount", accessor: "total_amt" },
        { header: "Balance", accessor: "balance" },
        { header: "Under Approval", accessor: "under_approval" },
        { header: "Status", accessor: "status" },
        { header: "Tags", accessor: "tags" },
        { header: "Action", accessor: "action" },
    ];

    const apiHandleFunction = async () => {
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                limit: itemsPerPage,
                offset,
            };
            const res = await getPaymentTransactionListApi(payload);
            if (res?.responseCode === 200) {
                setPaymentTransactionList(res?.data?.list);
                setTotalItem(res?.data?.total_record);
            }
        } catch (error) {
            console.error("Error fetching payment transactions:", error);
        }
    };

    const getStatusStyle = (status) => {
        const map = {
            Completed: { label: "Completed", color: "#22C55E" },
            Cancelled: { label: "Cancelled", color: "#EF4444" },
            Pending: { label: "Pending", color: "#F97316" },
        };
        return map[status] || { label: status || "-", color: "#6B7280" };
    };


    const handleRowClick = (item) => {
        console.log("jfdh", item)
        navigate(
            `/accounting/transactionExpDetails/${item._id}` +
            `?offset=${offset }` +
            `&total_record=${totalItems}` +
            `&type=1`+`&sequence_no=${item.original?.sequence_no}`
        );
    };

    const RowListData = (data = []) =>
        data.map(item => {
            const { label, color } = getStatusStyle(item?.status);

            return {
                _id: item._id,
                original: item,
                number: <span>
                    {item.sequence_no}
                </span>,
                voucher_date: item.date
                    ? new Date(item.date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
                    : "-",
                firm_name: <CustomToolTip>{item?.firm?.firm || "-"}</CustomToolTip>,
                vendor: (
                    <>
                        <CustomToolTip><div>{item?.vendor_detail?.name || "-"}</div>
                            <small className="text-muted">Vendor Type {item.vendor_type || ""}</small></CustomToolTip>

                    </>
                ),
                total_amt: `₹${(item.total_amount || 0).toLocaleString()}`,
                balance: `₹${(item.due_amount || 0).toLocaleString()}`,
                under_approval: `₹ ${(item.approval_amount || 0).toFixed(2)}`,
                status: <span className="trs-status" style={{ background: color }}>{label}</span>,
                tags: (
                    <div className="d-flex gap-1 flex-wrap">
                        {Object.values(item.tags || {}).map((tag, i) => (
                            <span key={i} className="tag-badge-bx">{tag}</span>
                        ))}
                    </div>
                ),
                action: <div className="_rSide_drp">
                    <div className="signDropdown">
                        <button
                            className="dropbtn11"
                        // onClick={(e) => e.stopPropagation()}

                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                            >
                                <rect
                                    x="0.390625"
                                    y="0.390625"
                                    width="24.2188"
                                    height="24.2188"
                                    rx="2.73438"
                                    stroke="#0049D7"
                                    strokeWidth="0.78125"
                                />
                                <path
                                    d="M12.5 7.8125C13.3629 7.8125 14.0625 7.11295 14.0625 6.25C14.0625 5.38706 13.3629 4.6875 12.5 4.6875C11.6371 4.6875 10.9375 5.38706 10.9375 6.25C10.9375 7.11295 11.6371 7.8125 12.5 7.8125Z"
                                    fill="#0049D7"
                                />
                                <path
                                    d="M12.5 14.0625C13.3629 14.0625 14.0625 13.3629 14.0625 12.5C14.0625 11.6371 13.3629 10.9375 12.5 10.9375C11.6371 10.9375 10.9375 11.6371 10.9375 12.5C10.9375 13.3629 11.6371 14.0625 12.5 14.0625Z"
                                    fill="#0049D7"
                                />
                                <path
                                    d="M12.5 20.3125C13.3629 20.3125 14.0625 19.6129 14.0625 18.75C14.0625 17.8871 13.3629 17.1875 12.5 17.1875C11.6371 17.1875 10.9375 17.8871 10.9375 18.75C10.9375 19.6129 11.6371 20.3125 12.5 20.3125Z"
                                    fill="#0049D7"
                                />
                            </svg>
                        </button>
                        <div className="dropdownContent">
                            {/* <Link
                                  // to={`/setting/user/adduser/${item?.user_id?._id}`}
                                  className="_avPointer"
                                  style={{ textDecoration: "none" }}
                                >
                                  <span className="_samAnchor">
                                    <span className="viewIcon_avt">
                                      <FiEdit />
                                    </span>{" "}
                                    Edit
                                  </span>
                                </Link> */}

                            {/* {item?.type != 21 && <div
                                // onClick={(e) => {

                                //     handleDelteSubmit(item);
                                //     e.stopPropagation();
                                // }}
                                className="_avPointer"
                            >
                                <span className="_samAnchor">
                                    <span className="deleteIcon_avt">
                                        <FaRegTrashCan color="red" />
                                    </span>{" "}
                                    Delete
                                </span>
                            </div>} */}
                        </div>
                    </div>
                </div>,
            };
        });


    const tabProps = {
        tabList: constant.accountTransactionTabs,
        callBackTab: setActiveTab,
        activeTab,
    };

    const handlePageChange = (page) => {
        setOffset(page);
    };

    useEffect(() => {
        apiHandleFunction(offset);
    }, [offset]);


    return (
        <div className='transation-all-mainBx'>
            <ButtonHeading
                title="Transactions"
                buttonTitle="Add Transactions"
                onClick={() => console.log("Add Transactions clicked")}
                className="transactions-head-button"
            />

            <div className="addPr_flBx __uiTx_new">
                <Tab {...tabProps} />

                <div className='transation-subContents'>
                    {activeTab === 1 &&
                        <div className='transaction-exp-bxs'>
                            <div className='trs-exp-head'>
                                <div className='trs-datePicker'><CommonDateRange /></div>
                                <div className="_inpW_search _lrl_inpSrch">
                                    {/* search svg ... */}
                                    <input type="text" placeholder="Search" className="simpleFilter_input" name="search" />
                                </div>
                            </div>

                            <div className='trs-exp-table'>
                                <BootstrapTable
                                    tableClass="trs-exp-table-inner"
                                    columns={columns}
                                    data={RowListData(paymentTransactionList)}
                                    onRowClick={(e, row) => handleRowClick(row)}
                                />
                                <div className='paginationFt_avt'>
                                    <CustomPagination
                                        totalItems={totalItems}
                                        itemsPerPage={itemsPerPage}
                                        currentPage={offset}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {activeTab === 2 && <>Servicing</>}
                    {activeTab === 3 && <>EMI</>}
                    {activeTab === 4 && <>Documents</>}
                    {activeTab === 5 && <>Salary</>}
                    {activeTab === 6 && <>Purchase</>}
                    {activeTab === 7 && <>Pay Claim</>}
                    {activeTab === 8 && <>Charge Claim</>}
                </div>
            </div>
        </div>
    );
};

export default PaymentTransaction;